import { Bonus } from "kinnect-models";
import { KForm, KDatePicker, KTextField } from "kinnect-general";
import { FetchesData } from "kinnect-mixins";
import { formatCurrency } from "kinnect-formatters";

export default KForm.extend( {
	name: "BonusForm",

	mixins: [ FetchesData ],

	props: {
		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "bonus" } ]
		}
	},

	data: () => ( {
		bonus: null,
		formFields: {
			asOfDate: null,
			pointValue: null
		}
	} ),

	watch: {
		bonus: {
			handler( bonus ) {
				if ( bonus ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( bonus.hasOwnProperty( key ) ) {
							this.formFields[key] = bonus[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	methods: {
		async fetchBonus() {
			this.bonus = await Bonus.first();
		},

		async fetch() {
			await this.fetchBonus();
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: "bonus",
				data: this.formFields,
				loading: this.$wait.is( "get bonuses" ),
				method: "post"
			}}
			on={this.$listeners}
		>
			<KTextField
				hint={this.formFields.pointValue
					? formatCurrency( parseFloat( this.formFields.pointValue ) )
					: ""
				}
				label="Point Value*"
				persistentHint
				prependIcon="attach_money"
				type="number"
				vModel={this.formFields.pointValue}
				validationName="point value"
				validationRules="required|money"
			></KTextField>

			<KDatePicker
				textFieldProps={{
					label: "Updated as of*",
					required: true,
					validationName: "start date",
					validationRules: "required"
				}}
				vModel={this.formFields.asOfDate}
			></KDatePicker>
		</KForm>;
	}
} );
